import { render, staticRenderFns } from "./PersonnelRecordDetails.vue?vue&type=template&id=5bfe676d"
import script from "./PersonnelRecordDetails.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetails.vue?vue&type=script&lang=js"
import style0 from "./PersonnelRecordDetails.vue?vue&type=style&index=0&id=5bfe676d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports